import styled from 'styled-components';
import colors from '../../../../config/colors.json';

export const StyledReportShow = styled.div`
  font-family: Poppins, Heltica, Arial, sans-serif;
  
  &.loading-page {
    height: calc(100% - 120px);
  }
  
  a.link-back {
    display: inline-block;
    font-size: 1.4em;
    color: #2B2932;
    margin: 20px 0;
  }
  
  .channel {
    -webkit-print-color-adjust: exact !important;
    width: 100% !important;
    margin-top: 30px;
    background-color: #FFFFFF;
    box-shadow: 0 3px 4px rgba(0,0,0,.2);
    padding: 0;
    border-radius: 7px;
    
    .dropdown {
      header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 85px;
        padding: 0 20px;
        border-radius: 7px;
      }
      
      span.text-header {
        font-family: Poppins-Medium, Heltica, Arial, sans-serif;
        font-size: 14px;
        display: block;
        margin: 0 15px;
      }
      
      .btn-dropdown {
        position: absolute;
        top: 25px;
        right: 20px;
        cursor: pointer;
        color: #707070;
        font-size: 35px;
      }
      
      hr {
        margin: 10px 0 20px 0;
      }
      
      .content {
        padding: 0 20px 15px 20px;
        
        * {
          margin: 0;
        }
      }
    }
  }

  @media print{
    width: 100% !important;

    .channel {
      margin-top: 30px;
      background-color: #FFFFFF;
      box-shadow: 0 3px 4px rgba(0,0,0,.2);
      padding: 0;
      border-radius: 7px;
      
      .dropdown {
        header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 85px;
          padding: 0 20px;
          border-radius: 7px;
        }
        
        span.text-header {
          font-family: Poppins-Medium, Heltica, Arial, sans-serif;
          font-size: 14px;
          display: block;
          margin: 0 15px;
        }
        
        .btn-dropdown {
          position: absolute;
          top: 25px;
          right: 20px;
          cursor: pointer;
          color: #707070;
          font-size: 35px;
        }
        
        hr {
          margin: 10px 0 20px 0;
        }
        
        .content {
          padding: 0 20px 15px 20px;
          
          * {
            margin: 0;
          }
        }
      }
    }
  }
`;

export const Inline = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const Title = styled.h1`
    font-size: 16px;
    color: ${colors.darkGrey};
    font-weight: 600;
    margin-bottom: 30px;
`;
